import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';

const LiveSessionCardsList = Loadable(
	lazy(() => import('modules/LiveSessionCard/pages/LiveSessionCardsList')),
);

const AddLiveSessionCard = Loadable(
	lazy(() => import('modules/LiveSessionCard/pages/AddLiveSessionCard')),
);

const UpdateLiveSessionCard = Loadable(
	lazy(() => import('modules/LiveSessionCard/pages/UpdateLiveSessionCard')),
);

const LIVE_SESSION_CARDS_ROUTES: IRoute[] = [
	{
		path: 'live-session-cards',
		element: LiveSessionCardsList,
		name: 'LiveSessionCardsList',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'live-session-cards/add',
		element: AddLiveSessionCard,
		name: 'AddLiveSessionCard',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'live-session-cards/update/:cardId',
		element: UpdateLiveSessionCard,
		name: 'UpdateLiveSessionCard',
		roles: [ROLES.ADMIN],
		private: true,
	},
];

export default LIVE_SESSION_CARDS_ROUTES;
